export default __webpack_public_path__ + "static/media/mobile.c053041d.png";